import { AxiosResponse } from "axios"

/**
 * A file instance is a blob that has been converted to an object URL with additional metadata.
 *
 * The objectURL lives for the lifetime of the document (or until manually revoked).
 * The browser will garbage collect the underlying blob when no references remain.
 */
export interface FileInstance {
  readonly blob: Blob
  readonly objectUrl: string
  readonly fileName: string
  readonly mimeType: string
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const makeFileInstance = ({ data: blob, headers }: AxiosResponse<Blob, any>) => {
  if (!blob) {
    return undefined
  }

  const objectUrl = URL.createObjectURL(blob)
  const contentDisposition = String(headers["content-disposition"] ?? "")
  const contentType = String(headers["content-type"] ?? "")

  const instance: FileInstance = {
    blob,
    objectUrl,
    // Content-Disposition: attachment; filename="filename.jpg"
    fileName: contentDisposition
      ? decodeURIComponent(contentDisposition.substring(22, contentDisposition.length - 1))
      : "unknown_file",
    mimeType: contentType.split(";")[0],
  }

  return instance
}

export const downloadFileInstance = (fileInstance: FileInstance) => {
  const link = document.createElement("a")
  link.style.display = "none"
  link.href = fileInstance.objectUrl
  link.download = fileInstance.fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
